<template>
  <!-- 走进武夷山 -->
  <div :key="domKey">
    <div style="position:relative">
      <TopButtom
        v-bind:buttonlist="buttonlist"
        v-on:changeDataList="changeDataList"
      ></TopButtom>
    </div>
    <div class="food">
      <!-- 左边 -->
      <div class="rowA" v-show="deviceId == 1">
        <div class="english">INTERMEDIATE TOUR GUIDE</div>
        <div class="chinese">中级导游</div>
      </div>
      <div class="rowA" v-show="deviceId == 2">
        <div class="english">STAR TOUR GUIDE</div>
        <div class="chinese">星级导游</div>
      </div>
      <div class="rowA" v-show="deviceId == 3">
        <div class="english">SPECIAL TOUR GUIDE</div>
        <div class="chinese">特色导游</div>
      </div>
      <!-- 中间 -->
      <div class="rowB">
        <div class="body">         
          <CardList :deviceId="deviceId"></CardList>      
        </div>
      </div>

      <!-- 右边 -->
      <div class="rowC">
        <div class="layout">
          <div style="writing-mode:vertical-rl;display:flex;flex-direction:row">
            <div style="margin-top:11px;">武夷山景区</div>
            <div style="margin-top:11px">天下难寻</div>
            <div style="margin-top:11px">Wuyi</div>
            <div>Mountain</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import TopButtom from "@/components/common/TopButtom.vue";
import CardList from "@/views/guide/cardList.vue";
export default {
  name: "TabGuide",
  components: { TopButtom,CardList},
  data() {
    return {
      domKey:'',
      datalist: [],
      buttonlist: [
        {
          id: 1,
          leftS: "left:1.5625vw",
          leftX: "left:1.458vw",
          title: "中级导游",
          noCheckX: false
        },
        {
          id: 2,
          leftS: "left:10.5208vw",
          leftX: "left:10.4167vw",
          title: "星级导游",
          noCheckX: true
        },
        {
          id: 3,
          leftS: "left:19.479vw",
          leftX: "left:19.375vw",
          title: "特色导游",
          noCheckX: true
        }
      ]
    };
  },
  watch: {
    deviceId: {
      handler(deviceId) {
        let timestamp = Date.parse(new Date())
        this.domKey = timestamp
        this.buttonlist.forEach(element => {
          element.id == deviceId? (element.noCheckX = false): (element.noCheckX = true);
        });
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    deviceId() {
      return this.$store.state.tabPage;
    }
  },
  methods: {
    //切换标签
    changeDataList(type) {
      this.$store.commit("setTabPage", type);
      let name = "TabGuide";
      this.$emit("specialtyListFunction", name);
    },
     
  }
};
</script>

<style scoped>
.food {
  height: 85.555vh;
  background: url(../../assets/image/logoBottom.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
}
.food .rowA {
  display: flex;
  flex-direction: row;
  margin-top: 6%;
  margin-left: 9.67%;
}
.food .rowB {
  width: 100%;
  margin-top: 16.2037vh;
  position: relative;
  display: flex;
  flex-direction: column;
  animation: bounceInRight 2s 
}

.food .rowB .body {
}


.food .rowC {
  padding: 0px 0.3645vw 0px 0.3645vw;
  height: 26.4814vh;
  line-height: 1.57407vh;
  background: #d87001;
  color: #ffffff;
  margin-top: 2.6851vh;
  margin-right: 1.0416vw;
  animation: bounceInRight 2s;
  font-size: 1.2962vh;

}
.food .rowB .topFont {
  font-size: 1.66667vh;
  font-family: "Microsoft YaHei";
  font-weight: bold;
  color: #333333;
  line-height: 1.66667vh;
  margin-bottom: 1.388vh;
}
.food .chinese {
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #c45b0e;
  writing-mode: vertical-rl;
  margin-left: 0.833vh;
  width: 0.833vw;
  font-size: 0.833vw;
  font-weight: bold;
  color: #d87001;
}
.food .english {
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #c45b0e;
  writing-mode: vertical-rl;
  width: 0.833vw;
  font-size: 0.833vw;
  font-weight: bold;
  color: #d87001;
}
</style>



// WEBPACK FOOTER //
// src/views/guide/tabGuide.vue